import { encodeUrl, QueryParam } from './encodeUrl.ts';


export function openLinkInNewTab(url: string, params?: Record<string, QueryParam>) {
    window.open(encodeUrl(url, params), '_blank');
}
